import React from "react";
import { startTestUrl } from "/routes/routesUrls";
import { useHistory } from "react-router-dom";

const HomePage = () => {

    const history = useHistory();

    React.useEffect(() => {

        document.body.classList.add('layout--centered');
        return () => {
            document.body.classList.remove('layout--centered');
        };
    }, []);

    const goToTestPage = () => {

        history.push(startTestUrl);

    };

    return (
        <>
            <div className="section bg-primary-gradient-soft">
                <div className="container is-max-desktop">
                    <div className="tree__show tree-home my-25" style={{"--result": "119"}}>
                        <div className="tree__left">
                            <div className="tree-image"></div>
                            <div className="tree-birds">
                                <div className="tree-bird tree-bird-1"></div>
                                <div className="tree-bird tree-bird-2"></div>
                                <div className="tree-bird tree-bird-3"></div>
                                <div className="tree-bird tree-bird-4"></div>
                                <div className="tree-bird tree-bird-5"></div>
                                <div className="tree-bird tree-bird-6"></div>
                                <div className="tree-bird tree-bird-7"></div>
                                <div className="tree-bird tree-bird-8"></div>
                                <div className="tree-bird tree-bird-9"></div>
                                <div className="tree-bird tree-bird-10"></div>
                                <div className="tree-bird tree-bird-11"></div>
                                <div className="tree-bird tree-bird-12"></div>
                                <div className="tree-bird tree-bird-13"></div>
                            </div>
                            <div className="tree-text">
                                <p>Als Tiny am Bach ankam, hatte Ruby bereits ein riesiges Löwenzahnblatt im Maul und knabberte voller Genuss. „Das ist so gut“, mümmelte er genüsslich. Tiny war nervös. Sie richtete sich auf den Hinterbeinen auf, spitzte die Ohren und schnupperte aufgeregt. Doch alles war ruhig, kein Fuchsgeruch lag in der Luft. Nur gut, dass Füchse so stanken, dass man sie auch gegen den Wind riechen konnte. Vorsichtig knabberte auch Tiny an einer Dotterblume, nicht ohne immer wieder horchen und zu schnuppern. „Komm Tiny, du musst etwas fressen! Sonst bleibst du immer so ein Winzling. Hier, probier‘ das einmal! Du hast wieder einmal die allerbesten Delikatessen mit deiner feinen Nase gefunden.“ Nun grub auch Tiny ihre kleinen Vorderzähne in einen saftiges Blatt und genoss, dass sich ihr Magen zunehmend füllte. Doch was war das? Aus den Wipfeln der Bäume hatte sich ein bedrohlicher Schatten gelöst, der sich rasch näherte. Schon spürte Tiny das Trommeln der anderen Kaninchen, die mit ihren Hinterläufen vor der Gefahr warnten. Tiny stieß einen langgezogenen, schrillen Schrei aus: „Eule, eine Eule!“ Sie flüchtete sich tiefer die steile Böschung hinab und kroch zitternd unter das große, feuchte Blatt einer Klette. Sie kauerte sich zitternd darunter, hoffte, dass es ihren gesamten Körper bedeckte und sie nicht mehr so sehen war. Fest krallte sie sich in den Untergrund, damit ihr Körper durch die Anspannung das Zittern aufhörte. Das Wasser des Baches schwappte gegen ihren Bauch. Ruby hingegen war ihren natürlichen Kaninchen-Instinkten gefolgt und spurtete in Richtung der Kaninchenlöcher. Im Zickzack floh er über die Wiese, die nun völlig im Dunkeln lag. Über sich hörte er das leise Rauschen der Schwingen der Eule. Wann würde sie herabstürzen und ihren Schnabel in sein Fleisch schlagen? Rubys Lunge brannte, seine Hinterläufe schmerzten. Wo war das nächste Kaninchenloch? Ruby machte einen riesigen Satz und landete tatsächlich in der Nähe eines Eingangs des Baus. Mit letzter Kraft stürzte er sich in die Tiefe.</p>
                            </div>

                        </div>

                        <div className="tree__right">
                            <h1>Hallo beim Lerche Lesetest!</h1>
                            <div className="box my-lh">
                                <h2 className="is-success">Du bist Schüler*in</h2>
                                <p>und du hast bereits einen Test-Code. Dann starte den Lesetest.</p>
                                <div className="controls">
                                    <button onClick={goToTestPage} className="button button--direction-right is-rounded is-success">
                                        <span className="button__text">Zum Test</span>
                                        <span className="icon licon-arrow-circle-right"></span>
                                    </button>
                                </div>
                            </div>
                            <div className="box my-lh">
                                <h2 className="is-info">Sie sind Lehrer*in</h2>
                                <p>Alle Informationen zur Lerche Lesediagnose, wie Sie Tests einrichten und Ihre Klassen verwalten, erfahren sie hier:</p>
                                <div className="controls">
                                    <button onClick={()=>{window.open('https://www.jungoesterreich.at/fachinformation/lesediagnose');}} className="button button--direction-up is-rounded is-info">
                                        <span className="button__text">Alle Informationen</span>
                                        <span className="icon licon-arrow-square-out"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="section">
                <div className="container is-max-tablet">
                <h3>
				Ein Tool aus dem JUNGÖSTERREICH Bildungsmedienverlag
                </h3>
                <p>
                    Wenn Sie interessiert sind, an weiteren spannenden Produkten aus unserem Haus, sollten Sie hier starten: <a href="http://www.jungoesterreich.at">www.jungoesterreich.at</a>
                </p>
                </div>
            </div>
        </>
    );
};

export default HomePage;